export enum FetchPriorityEnum {
  Low = 'low',
  High = 'high',
}
